module.exports = __webpack_public_path__ + "static/media/thumbnail.4bb12d4f.jpg";